<template>
	<div class="card card-body card-information-container mb-4">
		<div class="d-flex card-banner-header">
			<button class="btn btn-sm btn-plain">
				<i class="bi-plus-circle"></i>
			</button>
			<span class="banner-title align-self-center mr-auto">
				{{formTitle}}
			</span>
		</div>

		<div class="mt-2 p-3">
			<div class="form-group">
				<label><b>Title</b></label>
				<input
					type="text"
					name="title"
					class="input form-control"
					placeholder="Title"
					autocomplete="off"
					v-model="title"
				/>
			</div>
			<!-- <div class="form-group">
				<label><b>Release Date</b></label>
				<input
					v-model="release_date"
					type="date"
					name="release"
					class="input form-control"
					placeholder="Realease Date"
					autocomplete="off"
				/>
			</div> -->
			<div class="form-group">
				<label><b>Information Type</b></label>
				<select class="form-control" v-model="type">
					<option
						:value="type.key"
						v-for="(type, index) in informationTypes"
						:key="index"
					>
						{{ type.label }}
					</option>
				</select>
			</div>

			<div class="form-group">
				<label><b>Information Visibility</b></label>
				<select class="form-control" v-model="visibility">
					<option
						:value="visibility.key"
						v-for="(visibility, index) in informationVisibility"
						:key="index"
					>
						{{ visibility.label }}
					</option>
				</select>
			</div>

			<div v-if="type === 'image_text'" class="form-group">
				<label for="image">Upload Image information Image</label>
				<button
					class="btn btn-sm btn-plain text-danger"
					v-if="previewImage !== ''"
					@click="removeImage"
				>
					<i class="bi-x-circle"></i> Remove Image
				</button>
				<div class="my-2 text-center preview-image" v-if="previewImage !== ''">
					<img class="img-fluid rounded" :src="previewImage" alt="Uploaded Image" />
				</div>
				<div v-if="isUploading && previewImage === ''" class="pc-image-empty">
					<div class="image-loading">
						<div class="is-loading"></div>
					</div>
				</div>
				<div
					v-else-if="previewImage === ''"
					class="pc-image-empty cursor-pointer pc-image-empty-promotion"
					@click="uploadImage('desktop_image')"
				>
					<div class="image-upload-placeholder">
						<i class="fi fi-rr-picture image-placeholder"></i>
						<div class="text-placeholder">Klik untuk upload.</div>
					</div>
				</div>
				<div class="pc-input-desc">
					Upload image dengan resolusi 1296x324px agar fit dengan ukuran banner.
				</div>
			</div>
			<div class="form-group buttons m-0 hidden">
				<input
					type="file"
					accept="image/*"
					class="input-file"
					ref="imageUploader"
					id="pc-product-images-file"
					@change="onInputImageChange"
					multiple
				/>
				<label
					for="pc-product-images-file"
					class="btn btn-primary"
					:class="{ 'is-loading': isUploading }"
					>Upload images</label
				>
				<div class="pc-input-desc">Make sure your image resolution is 1296x324 px</div>
			</div>

			<div>
				<ContentEditor v-model="description" />
			</div>
		</div>

		<div class="mt-3 d-flex justify-content-end">
			<button
				type="button"
				:disabled="isLoading"
				class="btn-outline outline-primary btn-sm mr-2"
				@click="$emit('close')"
			>
				Cancel
			</button>
			<button
				@click="submit"
				type="button"
				:disabled="isLoading || isInvalidForm"
				:class="[{ 'is-loading': isLoading }]"
				class="btn-outline outline-primary active btn-sm"
			>
				Submit
			</button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContentEditor from '@/components/ContentEditor.vue';
import mediaApi from '@/api/media';

const dayjs = require('dayjs');
const utcPlugin = require('dayjs/plugin/utc');
const timezonePlugin = require('dayjs/plugin/timezone');

// Extend dayjs with plugins
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);


export default {
	name: 'InformationForm',
	components: {
		ContentEditor,
	},
	props: {
		formType: {
			type: String,
			default: 'create',
		},
		config: {
			type: Object,
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			title: '',
			release_date: '',
			type: 'text',
			image: null,
			isUploading: false,
			description: '',
			visibility: 'seller',
			previewImage: '',
			stateUpload: '',
			informationTypes: [
				{ key: 'text', label: 'Text' },
				{ key: 'image_text', label: 'Image with text' },
			],
			informationVisibility: [
				{ key: 'seller', label: 'Seller' },
				{ key: 'supplier', label: 'Supplier' },
				{ key: 'seler_supliers', label: 'Seller & Supplier' },
			],
			formTitle: 'Buat Popup Informasi Baru',
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isInvalidForm() {
			const hasCommonFields = this.title && this.type && this.visibility;

			if (!hasCommonFields) {
				return true;
			}

			if (this.type === 'image_text') {
				return !this.image; // Description is optional for 'image_text'
			}

			if (this.type === 'text') {
				return !this.description || this.description === '<p></p>'; // Description is mandatory for 'text'
			}

			// Handle any other types if necessary
			return false;
		},

	},
	created() {
		if (this.config) {
			this.formTitle = 'Edit popup Informasi';
			// dayjs.tz.setDefault(this.user?.timezone);
			this.title = this.config?.title;
			this.type = this.config.type;
			this.visibility = this.config?.target;
			this.description = this.config?.description;
			this.previewImage = this.config?.picture ?? '';
			this.image = this.config?.picture ?? '';
			// this.release_date = dayjs.utc(this.config?.release_date).tz(this.user?.timezone).format('YYYY-MM-DD');
		}
	},
	methods: {
		submit() {
			const form = {
				title: this.title,
				description: this.description,
				type: this.type,
				// release_date: this.release_date,
				// estimated_release_date: this.release_date,
				target: this.visibility,
				is_active: this.config?.is_active,
			};

			if (form.type === 'image_text') {
				form.picture = this.image;
			} else {
				delete form.picture;
			}
			this.$emit('submit', form, this.formType, this.config?._id);
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			this.image = '';
			this.previewImage = '';
			this.isUploading = true;
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'popup-information',
						text: noticeMessage,
						type: 'warn',
					});
					this.isUploading = false;
					this.isUploadingMobile = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					this.image = url;
					this.previewImage = url;
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		removeImage() {
			this.previewImage = '';
			this.image = null;
		},
	},
};
</script>

<style lang="scss" scoped>
.pc-image-empty {
	height: 400px !important;
}
</style>
